import { render, staticRenderFns } from "./input-label.component.vue?vue&type=template&id=97aff288&scoped=true"
import script from "./input-label.component.vue?vue&type=script&lang=ts"
export * from "./input-label.component.vue?vue&type=script&lang=ts"
import style0 from "./input-label.component.vue?vue&type=style&index=0&id=97aff288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aff288",
  null
  
)

export default component.exports